module.exports = __webpack_public_path__ + "static/media/swift.b53edc9b.png";